import { useEffect, useState } from "react";
import api from "@/lib/api";
import { FileText } from "lucide-react";

const STATUS_COLOR = {
  "New": "text-primary border-primary/40",
  "In Review": "text-yellow-400 border-yellow-400/40",
  "Quoted": "text-blue-400 border-blue-400/40",
  "Won": "text-secondary border-secondary/40",
  "Closed": "text-muted-foreground border-border",
};

export default function Quotes() {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/quotes/mine").then((r) => setQuotes(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  return (
    <div data-testid="quotes-page">
      <div className="mb-8">
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-primary mb-2">/ Requests</p>
        <h1 className="font-display font-extrabold text-3xl md:text-4xl tracking-tight">Quote History</h1>
      </div>

      {loading ? (
        <p className="font-mono text-xs text-muted-foreground">Loading…</p>
      ) : quotes.length === 0 ? (
        <div className="border border-border p-12 text-center" data-testid="quotes-empty">
          <FileText size={28} className="mx-auto text-muted-foreground mb-4" />
          <p className="font-display font-bold text-xl tracking-tight mb-2">No requests yet</p>
          <p className="font-sans text-sm text-muted-foreground mb-6">Submit a quote request from the marketing site and it will appear here.</p>
          <a href="/#quote" className="inline-block bg-primary text-white px-6 py-3 font-mono text-xs uppercase tracking-wider hover:bg-white hover:text-black transition-colors">New Request</a>
        </div>
      ) : (
        <div className="border border-border overflow-x-auto thin-scroll">
          <table className="w-full text-left border-collapse min-w-[640px]">
            <thead>
              <tr className="border-b border-border bg-muted/40">
                {["Reference", "Service", "Assets", "Date", "Status"].map((h) => (
                  <th key={h} className="font-mono text-[10px] uppercase tracking-widest text-muted-foreground px-4 py-3">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {quotes.map((q) => (
                <tr key={q.id} data-testid="quote-row" className="border-b border-border hover:bg-muted/30 transition-colors">
                  <td className="px-4 py-3 font-mono text-sm text-primary">{q.reference}</td>
                  <td className="px-4 py-3 font-sans text-sm">{q.service}</td>
                  <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{q.asset_count || "—"}</td>
                  <td className="px-4 py-3 font-mono text-xs text-muted-foreground">{new Date(q.created_at).toLocaleDateString()}</td>
                  <td className="px-4 py-3">
                    <span className={`inline-block font-mono text-[10px] uppercase tracking-wider border px-2 py-1 ${STATUS_COLOR[q.status] || "text-muted-foreground border-border"}`}>
                      {q.status}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
